
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UscoreAdvertisement from "@/components/home/UscoreAdvertisement";
import EnhancedSeoMetadataComponent from "@/components/common/EnhancedSeoMetadata";
import { getEnhancedSeoDataForRoute } from "@/utils/enhancedSeoUtils";

const UlosottoPage = () => {
  const navigate = useNavigate();
  const seoData = getEnhancedSeoDataForRoute("/lainat/ulosottolaskuri");
  
  useEffect(() => {
    // Redirect to new URL while maintaining SEO value
    navigate("/lainat/ulosottolaskuri", { replace: true });
  }, [navigate]);
  
  return (
    <>
      <EnhancedSeoMetadataComponent
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonicalUrl="https://lainasampo.fi/lainat/ulosottolaskuri"
        schema={seoData.schema}
      />
      
      <div className="container mx-auto py-8 px-4">
        <UscoreAdvertisement />
      </div>
    </>
  );
};

export default UlosottoPage;
